import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { defaultWMS2091_R01DetailDto, defaultWMS2091_R01HeaderDto, defaultWMS2091_R01LotDto, WMS2091_R01DetailDto, WMS2091_R01HeaderDto, WMS2091_R01LotDto } from './Dto_WMS2091_R01';
import { showWarning } from 'src/utils/toast/toastUtil';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';

export interface WMS2091_R01Filter {
	transportNo: string;
	customCd: string;
	customNm: string;
	labelPrintAuto: string;
}
export interface Store_WMS2091_R01 {
	WMS2091_R01Filter: WMS2091_R01Filter;
	WMS2091_R01PastFilter: WMS2091_R01Filter;
	setWMS2091_R01Filter: (filter: Partial<Store_WMS2091_R01['WMS2091_R01Filter']>) => void;
	setWMS2091_R01PastFilter: (filter: Store_WMS2091_R01['WMS2091_R01PastFilter']) => void;
	
	// ====== 매출 리스트 및 선택/편집 ======
	WMS2091_R01List: WMS2091_R01HeaderDto[];
	setWMS2091_R01List: (dataList: WMS2091_R01HeaderDto[]) => void;

	editWMS2091_R01: WMS2091_R01HeaderDto | null;
	setEditWMS2091_R01: (editSale: WMS2091_R01HeaderDto | null) => void;

	selectedWMS2091_R01: WMS2091_R01HeaderDto | undefined;
	setSelectedWMS2091_R01: (data: WMS2091_R01HeaderDto | undefined) => void;
	initSelectedWMS2091_R01: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedWMS2091_R01DetailList: string[];
	setDeletedWMS2091_R01DetailList: (idList: string[]) => void;
	addDeletedWMS2091_R01DetailList: (idList: string[]) => void;
	removeDeletedWMS2091_R01DetailList: (idList?: string[]) => void;

	// ====== 매출 상세(디테일) 데이터 ======
	WMS2091_R01DetailList: WMS2091_R01DetailDto[];
	setWMS2091_R01DetailList: (data: WMS2091_R01DetailDto[]) => void;
	insertWMS2091_R01DetailList: (data: WMS2091_R01DetailDto[], index?: number) => void;
	removeWMS2091_R01DetailList: (index: number) => void;
	updateWMS2091_R01DetailList: (index: number, data: WMS2091_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedWMS2091_R01DetailList: string[];
	setSelectedWMS2091_R01DetailList: (idList: string[]) => void;
	addSelectedWMS2091_R01DetailList: (idList: string[]) => void;
	removeSelectedWMS2091_R01DetailList: (idList?: string[]) => void;
	initSelectedWMS2091_R01DetailList: () => void;

	originalWMS2091_R01DetailList: WMS2091_R01DetailDto[];
	setOriginalWMS2091_R01DetailList: (data: WMS2091_R01DetailDto[]) => void;

	// ====== 입고 상세(lot) 데이터 ======
	WMS2091_R01LotMap: Map<string, WMS2091_R01LotDto[]>;
	setWMS2091_R01LotMap: (data: Map<string, WMS2091_R01LotDto[]>) => void;
	
	selectedItemCdForLot: string | null;
	setSelectedItemCdForLot: (itemCd: string | null) => void;
	
	// LotTable의 핸들러들을 위한 함수. 현재 선택된 아이템의 Lot 리스트를 업데이트합니다.
	setWMS2091_R01LotList: (data: WMS2091_R01LotDto[]) => void;

	insertWMS2091_R01LotList: (data: WMS2091_R01LotDto[], index?: number) => void;
	removeWMS2091_R01LotList: (valueIndex: number) => void;
	updateWMS2091_R01LotList: (valueIndex: number, data: WMS2091_R01LotDto) => void;

	// ====== 입고 상세선택(lot) 행 선택/삭제 관리 ======
	selectedWMS2091_R01LotList: string[];
	setSelectedWMS2091_R01LotList: (idList: string[]) => void;
	addSelectedWMS2091_R01LotList: (idList: string[]) => void;
	removeSelectedWMS2091_R01LotList: (idList?: string[]) => void;
	initSelectedWMS2091_R01LotList: () => void;

	// ====== 입고 상세(lot) 행 선택/삭제 관리 ======
	deletedWMS2091_R01LotList: string[];
	setDeletedWMS2091_R01LotList: (idList: string[]) => void;
	addDeletedWMS2091_R01LotList: (idList: string[]) => void;
	removeDeletedWMS2091_R01LotList: (idList?: string[]) => void;

	originalWMS2091_R01LotList: WMS2091_R01LotDto[];
	setOriginalWMS2091_R01LotList: (data: WMS2091_R01LotDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;
	lotColumnState: ColumnState[] | null;
	setLotColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	
	allCount: number;				setAllCount: (allCount: number) => void;

	transportComplete: boolean;		setTransportComplete: (transportComplete: boolean) => void;
	detailFetchTrigger: boolean;	setDetailFetchTrigger: (detailFetchTrigger: boolean) => void;
	lotFetchTrigger: boolean;		setLotFetchTrigger: (lotFetchTrigger: boolean) => void;

	// ====== 초기화 ======
	initData: () => void;

	// 창고 코드 필터링 (로직센터 & 자재창고 여부)
	warehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	// 공통코드 로드 후 초기값 동기화
	syncInitialData: () => void;
}

export const defaultWMS2091_R01Filter : WMS2091_R01Filter = {
	transportNo: '',
	customCd: '',
	customNm: '',
	labelPrintAuto: 'N'
};

const getInitialWMS2091_R01HeaderDto = (): WMS2091_R01HeaderDto => {
	const { wmsCdList, warehouseCdList } = useCommonCodeStore.getState();
	return {
		...defaultWMS2091_R01HeaderDto,
		logicCenter: wmsCdList?.[0]?.minorCd || '',
		warehouseCd: warehouseCdList?.[0]?.warehouseCd || '',
	};
};

export const useWMS2091_R01Store = create<Store_WMS2091_R01>((set, get) => ({
	WMS2091_R01Filter: defaultWMS2091_R01Filter,
	WMS2091_R01PastFilter: defaultWMS2091_R01Filter,
	setWMS2091_R01Filter: (update) => set((state) => ({
		WMS2091_R01Filter: {
			...state.WMS2091_R01Filter,
			...update
		}
	})),
	setWMS2091_R01PastFilter: (filter: Store_WMS2091_R01['WMS2091_R01PastFilter']) => set((state) => {
		return {
			...state,
			WMS2091_R01PastFilter: filter
		}
	}),

	// ====== 매출 리스트 및 선택/편집 ======
	WMS2091_R01List: [],
	setWMS2091_R01List: (dataList: WMS2091_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			WMS2091_R01List: dataList
		}
	}),

	editWMS2091_R01: getInitialWMS2091_R01HeaderDto(),
	setEditWMS2091_R01: (editSale: WMS2091_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editWMS2091_R01: editSale
		}
	}),

	selectedWMS2091_R01: undefined,
	
	setSelectedWMS2091_R01: (data: WMS2091_R01HeaderDto | undefined) => set((state) => {
		// 탭 전환 시 그리드 리마운트로 인한 중복 선택 이벤트(트리거 오작동) 방어
		if (state.selectedWMS2091_R01 === data) return state;

		return { 
			selectedWMS2091_R01: data, 
			selectedWMS2091_R01DetailList: [], deletedWMS2091_R01DetailList: [],
			selectedWMS2091_R01LotList: [], deletedWMS2091_R01LotList: [],
			detailFetchTrigger: true,
		};
	}),
	initSelectedWMS2091_R01: () => set({ 
		selectedWMS2091_R01: undefined, 
		editWMS2091_R01: getInitialWMS2091_R01HeaderDto(), 
		WMS2091_R01DetailList: [],
		detailFetchTrigger: false,
	}),

	// ====== 매출 상세(디테일) 데이터 ======
	WMS2091_R01DetailList: [],
	setWMS2091_R01DetailList: (data: WMS2091_R01DetailDto[]) => set((state) => {
		let newList: WMS2091_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultWMS2091_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			WMS2091_R01DetailList: newList
		}
	}),
	insertWMS2091_R01DetailList: (data: WMS2091_R01DetailDto[], index?: number) => set((state) => {
		let newWMS2091_R01DetailList = [...state.WMS2091_R01DetailList];

		let targetRowData = newWMS2091_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newWMS2091_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newWMS2091_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newWMS2091_R01DetailList = newWMS2091_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newWMS2091_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultWMS2091_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newWMS2091_R01DetailList.splice(index, 0, ...newData);
		} else {
			newWMS2091_R01DetailList.push(...newData);
		}

		return {
			...state,
			WMS2091_R01DetailList: newWMS2091_R01DetailList
		}
	}),
	removeWMS2091_R01DetailList: (index: number) => set((state) => {
		const newWMS2091_R01DetailList = [...state.WMS2091_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			WMS2091_R01DetailList: newWMS2091_R01DetailList
		}
	}),
	updateWMS2091_R01DetailList: (valueIndex: number, data: WMS2091_R01DetailDto) => set((state) => {
		const _WMS2091_R01DetailList = state.WMS2091_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			WMS2091_R01DetailList: _WMS2091_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedWMS2091_R01DetailList: [],
	setDeletedWMS2091_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedWMS2091_R01DetailList: idList
		}
	}),
	addDeletedWMS2091_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedWMS2091_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.WMS2091_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.WMS2091_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedWMS2091_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedWMS2091_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedWMS2091_R01DetailList: [...state.deletedWMS2091_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedWMS2091_R01DetailList: [],
	setSelectedWMS2091_R01DetailList: (idList: string[]) => set((state) => {
		const foundItem = state.WMS2091_R01DetailList.find(
			(item) => item.valueIndex.toString() === idList[0]
		);
		const firstItemKey = foundItem ? `${foundItem.itemCd}-${foundItem.itemStatus}` : null;

		return {
			...state,
			selectedWMS2091_R01DetailList: idList,
			selectedItemCdForLot: firstItemKey,
		}
	}),
	addSelectedWMS2091_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedWMS2091_R01DetailList = [...state.selectedWMS2091_R01DetailList];
		if(idList.length > 0) {
			_selectedWMS2091_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedWMS2091_R01DetailList: _selectedWMS2091_R01DetailList
		}
	}),
	removeSelectedWMS2091_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedWMS2091_R01DetailList: [...state.selectedWMS2091_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedWMS2091_R01DetailList: () => set({ selectedWMS2091_R01DetailList: [] }),

	originalWMS2091_R01DetailList: [],
	setOriginalWMS2091_R01DetailList: (data: WMS2091_R01DetailDto[]) => set((state) => {
		let newList: WMS2091_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultWMS2091_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalWMS2091_R01DetailList: newList
		}
	}),

	// ====== 입고 상세(lot) 데이터 ======
	WMS2091_R01LotMap: new Map<string, WMS2091_R01LotDto[]>(),
	setWMS2091_R01LotMap: (data: Map<string, WMS2091_R01LotDto[]>) => set({ WMS2091_R01LotMap: data }),

	selectedItemCdForLot: null,
	setSelectedItemCdForLot: (itemCd) => set({ selectedItemCdForLot: itemCd }),

	setWMS2091_R01LotList: (data: WMS2091_R01LotDto[]) => set((state) => {
		const { WMS2091_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state; // 선택된 아이템이 없으면 아무것도 하지 않음

		const newLotMap = new Map(WMS2091_R01LotMap);
		newLotMap.set(selectedItemCdForLot, data);

		return { WMS2091_R01LotMap: newLotMap };
	}),

	insertWMS2091_R01LotList: (data: WMS2091_R01LotDto[], index?: number) => set((state) => {
		const { WMS2091_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state;

		const newLotMap = new Map(WMS2091_R01LotMap);
		let targetList = [...(newLotMap.get(selectedItemCdForLot) || [])];

		let targetRowData = targetList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...targetList.map(item => item.valueIndex || 0)) + 1;

		// newTargetList에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = targetList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		targetList = targetList.filter(item => item.orderIndex !== targetOrderIndex);
		targetList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultWMS2091_R01LotDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			targetList.splice(index, 0, ...newData);
		} else {
			targetList.push(...newData);
		}
		
		newLotMap.set(selectedItemCdForLot, targetList);
		return { WMS2091_R01LotMap: newLotMap };
	}),

	removeWMS2091_R01LotList: (valueIndex: number) => set((state) => {
		const { WMS2091_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state;

		const newLotMap = new Map(WMS2091_R01LotMap);
		const targetList = (newLotMap.get(selectedItemCdForLot) || []).filter(item => item.valueIndex !== valueIndex);
		
		newLotMap.set(selectedItemCdForLot, targetList);
		return { WMS2091_R01LotMap: newLotMap };
	}),

	updateWMS2091_R01LotList: (valueIndex: number, data: WMS2091_R01LotDto) => set((state) => {
		const { WMS2091_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state;

		// inputOutQty가 유효한 숫자인지 확인하고, 아니면 0으로 설정
		if (typeof data.inputOutQty !== 'number' || isNaN(data.inputOutQty)) {
			showWarning('입고량은 숫자만 입력할 수 있습니다.');
			data.inputOutQty = 0;
		}
		if(data.inputOutQty > data.lotQty) {
			showWarning('입고량은 재고량보다 클 수 없습니다.');
			data.inputOutQty = data.lotQty;
		}
		if(data.inputOutQty < 0) {
			showWarning('입고량은 0보다 작을 수 없습니다.');
			data.inputOutQty = 0;
		}

		const newLotMap = new Map(WMS2091_R01LotMap);
		const targetList = (newLotMap.get(selectedItemCdForLot) || []).map(item =>
			item.valueIndex === valueIndex ? { ...data, isModified: Number(data.inputOutQty) > 0 ? true : false } : item
		);

		newLotMap.set(selectedItemCdForLot, targetList);
		return { WMS2091_R01LotMap: newLotMap };
	}),
	
	// ====== 입고 상세(lot) 행 선택/삭제 관리 ======
	deletedWMS2091_R01LotList: [],
	setDeletedWMS2091_R01LotList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedWMS2091_R01LotList: idList
		}
	}),
	addDeletedWMS2091_R01LotList: (idList: string[]) => set((state) => {
		const _deletedLotList = [...state.deletedWMS2091_R01LotList];
		const selectedItemKey = state.selectedItemCdForLot;
		const newWMS2091_R01LotList = [...state.WMS2091_R01LotMap.get(selectedItemKey!) || []];

		for(const valueIndex of idList) {
			const isInserted = newWMS2091_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = newWMS2091_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedLotList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedWMS2091_R01LotList: _deletedLotList,
		}
	}),
	removeDeletedWMS2091_R01LotList: (idList?: string[]) => set((state) => ({
		...state,
		deletedWMS2091_R01LotList: [...state.deletedWMS2091_R01LotList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedWMS2091_R01LotList: [],
	setSelectedWMS2091_R01LotList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedWMS2091_R01LotList: idList,
		}
	}),
	addSelectedWMS2091_R01LotList: (idList: string[]) => set((state) => {
		const _selectedWMS2091_R01LotList = [...state.selectedWMS2091_R01LotList];
		if(idList.length > 0) {
			_selectedWMS2091_R01LotList.push(...idList);
		}
		return {
			...state,
			selectedWMS2091_R01LotList: _selectedWMS2091_R01LotList
		}
	}),
	removeSelectedWMS2091_R01LotList: (idList?: string[]) => set((state) => ({
		...state,
		selectedWMS2091_R01LotList: [...state.selectedWMS2091_R01LotList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedWMS2091_R01LotList: () => set({ selectedWMS2091_R01LotList: [] }),	

	originalWMS2091_R01LotList: [],
	setOriginalWMS2091_R01LotList: (data: WMS2091_R01LotDto[]) => set((state) => {
		let newList: WMS2091_R01LotDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultWMS2091_R01LotDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalWMS2091_R01LotList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),
	lotColumnState: null,
	setLotColumnState: (state: ColumnState[] | null) => set({ lotColumnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

	transportComplete: false,		setTransportComplete: (transportComplete: boolean) => set({ transportComplete }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (detailFetchTrigger: boolean) => set({ detailFetchTrigger }),
	lotFetchTrigger: false,			setLotFetchTrigger: (lotFetchTrigger: boolean) => set({ lotFetchTrigger }),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		WMS2091_R01Filter: defaultWMS2091_R01Filter,
		WMS2091_R01PastFilter: defaultWMS2091_R01Filter,
		WMS2091_R01List: [],
		selectedWMS2091_R01: undefined,
		WMS2091_R01DetailList: [],
		deletedWMS2091_R01DetailList: [],
		selectedWMS2091_R01DetailList: [],
		editWMS2091_R01: getInitialWMS2091_R01HeaderDto(),
		WMS2091_R01LotMap: new Map<string, WMS2091_R01LotDto[]>(),
		selectedItemCdForLot: null,
		originalWMS2091_R01LotList: [],
		deletedWMS2091_R01LotList: [],
		selectedWMS2091_R01LotList: [],
		allCount: 0,
		
		transportComplete: false,
		detailFetchTrigger: false,
		lotFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,
	})),

	warehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		const filteredList = warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& value.materialYn === 'Y'
		));
		
		if (filteredList.length === 0) {
			return [{ warehouseCd: '', warehouseNm: '' } as WareHouseDto];
		}
		
		return filteredList;
	},

	syncInitialData: () => {
		const { wmsCdList } = useCommonCodeStore.getState();
		const state = get();
		
		// 이미 값이 있거나 공통코드가 없으면 리턴
		if ((state.editWMS2091_R01?.logicCenter && state.editWMS2091_R01?.warehouseCd) || wmsCdList.length === 0) return;

		const defaultLogicCenter = wmsCdList?.[0]?.minorCd || '';
		
		// 스토어 내부 함수를 사용하여 유효한 창고 목록을 가져옴
		const availableWarehouses = state.warehouseCdListToUseList(defaultLogicCenter);
		const defaultWarehouseCd = availableWarehouses?.[0]?.warehouseCd || '';
		const defaultWarehouseNm = availableWarehouses?.[0]?.warehouseNm || '';

		set((state) => ({
			editWMS2091_R01: {
				...state.editWMS2091_R01!,
				logicCenter: defaultLogicCenter,
				warehouseCd: defaultWarehouseCd,
				warehouseNm: defaultWarehouseNm,
			}
		}));
	},

	
}));


